import { Heading, IHeadingProps } from 'native-base';
import React, { ReactNode } from 'react';

export type ShadowTextProps = IHeadingProps & {
  children?: ReactNode;
};

export default function ShadowText({ children, fontSize = 'xl', ...props }: ShadowTextProps) {
  return (
    <Heading
      color="white"
      fontFamily={props.fontWeight === 'normal' ? 'ProximaNova' : undefined}
      fontSize={fontSize}
      style={{ textShadowColor: 'rgba(0,0,0,.4)', textShadowRadius: 8 }}
      textAlign="center"
      {...props}
    >
      {children}
    </Heading>
  );
}
